import { render, staticRenderFns } from "./update-wallet-settings.vue?vue&type=template&id=444461e4&scoped=true"
import script from "./update-wallet-settings.vue?vue&type=script&lang=js"
export * from "./update-wallet-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444461e4",
  null
  
)

export default component.exports